import type React from 'react';

import { Button, HeroLayout, Image, Text } from '@change/ds-core-ui';

import { useCTASection } from './hooks';

export const CTASection: React.FC = () => {
	const {
		data: { ctaSection },
	} = useCTASection();

	if (!ctaSection) {
		return null;
	}

	const {
		title,
		ctaText,
		image: { src, alt },
	} = ctaSection;

	return (
		<HeroLayout media={<Image src={src} className="h-full w-full object-cover" alt={alt} />}>
			<div className="bg-gradient-background-dark-3 flex h-full flex-col justify-center gap-6 p-6 md:p-12">
				<Text as="h2" variant="heading" className="text-typography-inverse-strong-fixed max-w-[600px]">
					{title}
				</Text>
				<div className="flex w-full gap-4 max-lg:flex-col">
					<Button
						variant="primary"
						data-qa="footer-sap-button"
						size="large"
						className="max-w-none max-lg:w-full"
						as="a"
						href="/start-a-petition/intro?source_location=petition_guides_category"
					>
						{ctaText}
					</Button>
				</div>
			</div>
		</HeroLayout>
	);
};
